module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row agent d-flex align-items-end mb-3"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Commission to:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getAgents,
      "placeholder": "- Select person -",
      "label": "name"
    },
    on: {
      "input": _vm.updateAgent
    },
    model: {
      value: (_vm.selectedAgent),
      callback: function($$v) {
        _vm.selectedAgent = $$v
      },
      expression: "selectedAgent"
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4d86c613", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d86c613"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Agent.vue
// module id = 2029
// module chunks = 0